// extracted by mini-css-extract-plugin
module.exports = {"video_container":"styles_video_container__M9Ybi","video_player":"styles_video_player__E_bCI"};